export const HOLIDAY = 'holiday@allholiday';

export default {
    [HOLIDAY]: {
        url: 'holiday/get/all',
    }
};
